<ion-chip color="secondary" shape="round" fill="solid" class="balance-chip" (click)="openCard($event)">
  <small *ngIf="!isLoading"> ${{ getFormattedBalance() }}&nbsp; </small
  ><ion-spinner *ngIf="isLoading" color="secondary" name="dots"></ion-spinner>&nbsp;
  <!-- <small *ngIf="!isLoading"> &nbsp; </small
  ><ion-spinner *ngIf="isLoading" color="secondary" name="dots"></ion-spinner>&nbsp; -->
</ion-chip>
